import { combineReducers } from 'redux'
import all from 'components/bah/reducers/all'
import byRank from 'components/bah/reducers/byRank'

export default combineReducers({
  all,
  byRank,
})
